import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconQuestionMark12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconQuestionMark12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.983 3.115C4.193 2.32 5.067 1.5 6.131 1.5c.559 0 1.02.167 1.336.46.31.29.533.748.533 1.44 0 .562-.133.92-.309 1.19-.187.285-.44.5-.758.76l-.035.03c-.295.241-.65.532-.921.931C5.682 6.745 5.5 7.282 5.5 8a.5.5 0 0 0 1 0c0-.532.13-.87.304-1.127.187-.275.44-.484.763-.749l.005-.004c.305-.25.675-.553.956-.982C8.82 4.692 9 4.138 9 3.4c0-.922-.306-1.663-.852-2.172C7.608.726 6.884.5 6.13.5 4.575.5 3.333 1.665 3.017 2.859a.5.5 0 0 0 .966.256M6 11.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconQuestionMark12);
